import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { read, write } from '../lib/store.js';

export function renderRecruitForm(onSubmitted) {
  const mount = $('#recruit-form');
  if (!mount) return;
  const form = document.createElement('form');
  form.className = 'form';
  form.innerHTML = `
    <div>
      <label>// Government name</label>
      <input required name="name" placeholder="Tom R." />
    </div>
    <div>
      <label>// IGN</label>
      <input required name="ign" placeholder="TILTERTOM" />
    </div>
    <div>
      <label>// Number of children</label>
      <select required name="kids">
        <option value="">— SELECT —</option>
        <option>0 (we're flexible)</option>
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4+</option>
        <option>One on the way</option>
      </select>
    </div>
    <div>
      <label>// Current rank</label>
      <select required name="rank">
        <option value="">— SELECT —</option>
        <option>Mythic Glory</option>
        <option>Mythic</option>
        <option>Legend</option>
        <option>Epic (and tired)</option>
        <option>I haven't played since fatherhood</option>
      </select>
    </div>
    <button type="submit">SUBMIT TRYOUT →</button>
    <div class="helper">We'll text you between 21:30 and 23:00 only.</div>
  `;
  form.addEventListener('submit', e => {
    e.preventDefault();

    const submission = {
      ts:   new Date().toISOString(),
      name: (form.querySelector('[name=name]').value || '').trim(),
      ign:  (form.querySelector('[name=ign]').value  || '').trim(),
      kids: (form.querySelector('[name=kids]').value || '').trim(),
      rank: (form.querySelector('[name=rank]').value || '').trim()
    };

    try {
      const current = read('applications');
      write('applications', [submission, ...current]);
    } catch {
      // Storage may be unavailable (private mode, quota). Don't block the UX —
      // the confirmation still shows; the submission is only lost locally.
    }

    const ignRaw = (submission.ign || 'DAD').toUpperCase();
    const ign = esc(ignRaw);
    const sub = document.createElement('div');
    sub.className = 'form submitted';
    sub.innerHTML = `
      <div class="big">Application received.</div>
      <p style="color:#ffd0b3;max-width:32ch;margin:12px 0">
        You'll hear back within 24 hours — or 72 if the baby has a fever.
      </p>
      <div class="helper">// File: APP_${ign}.TXT</div>
    `;
    form.replaceWith(sub);
    if (typeof onSubmitted === 'function') onSubmitted(sub);
  });
  mount.appendChild(form);
  if (typeof onSubmitted === 'function') onSubmitted(form);
}
